export default __webpack_public_path__ + "static/media/close-icon.2ef342b3.svg";